import WelcomeHomePage from "./WelcomeHomePage";

export default WelcomeHomePage;
